<template>
  <cube-slide ref="slide" :data="slideImg" class="slide">
    <cube-slide-item v-for="(item, index) in slideImg" :key="index" @click.native="toPage(item.url)">
      <img :src="item.src">
    </cube-slide-item>
  </cube-slide>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import { querybackground } from '@/api/background'

export default {
  name: 'indexSwiper',
  data () {
    return {
      mySwiper: null,
      slideImg: [{
        src: '',
        url: ''
      }, {}, {}],
      swiperOption: {
        autoplay: true,
        notNextTick: true,
        initialSlide: 1,
        loop: true,
        pagination: '.swiper-pagination'
      }
    }
  },
  methods: {
    swiperInit () {
      let _this = this
      this.mySwiper = new Swiper('.swiper-container', {
        initialSlide: 0,
        loop: false,
        autoplay: true,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loopedSlides: this.slideImg.length,
        observeParents: true,
        on: {
          // 使用es6的箭头函数，使this指向vue对象
          click: () => {
            let i = _this.mySwiper.activeIndex
            _this.toPage(_this.slideImg[i].url)
          }
        }
      })
      return this.mySwiper
    },
    getData () {
      if (this.$route.path !== '/home') return

      if (!this.$store.state.token.token) {
        setTimeout(() => {
          this.$dfzhJsBridge.goLogout()
        }, 1000)
        return
      }

      querybackground({
        typeCode: '22'
      }).then((res) => {
        console.log('queryback  code=' + res.code + '   total=' + res.data.total)

        if (res.data.total > 0) {
          const list = res.data.records[0].imgList
          list.sort(this.compare('sort'))
          this.slideImg.splice(0)
          list.forEach((item, idx) => {
            this.slideImg.push({
              src: item.resUrl,
              url: item.url
            })
          })
          console.log(this.slideImg)

          // this.swiperInit()
        }
      }).catch(e => {
        console.error(e.message)
      })
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    toPage (url) {
      console.log('toPage url=' + url)
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.switchTab({ url: '/pages/course/course' })
        return
      }

      if (!url || url === '') {
        url = '/learn'
      }

      this.$router.push({
        path: url
      })
    }
  },
  mounted () {
    console.log('swiper token' + this.$route.query.token)
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }
    this.getData()
  }

}
</script>

<style lang="stylus">
.slide
  .swiper-container,.swiper-slide,img
    width: 100%
    height: 149px
  .cube-slide-dots
    bottom 16px
    span
      width 10px
      height 10px
      border-radius 50%
      background-color #8B8784
      margin-left 6px
    span.active
      background-color #4D4D4D
</style>
